import { getCookie, setCookie } from '@utilities/cookies';

export class LanguageService {
  private static cookieName = 'esiForcedLanguage';

  static siteLanguages = ['en', 'fr', 'de', 'it', 'es', 'pt', 'ru'];

  static get cookieLanguage() {
    const lang = getCookie(this.cookieName);
    return this.isValid(lang) ? lang : 'en';
  }

  static set cookieLanguage(lang: string) {
    if (!this.isValid(lang)) return;

    setCookie(this.cookieName, lang, {
      expires: 365,
      path: '/',
      domain: location.hostname === 'localhost' ? 'localhost' : '.uefa.com',
    });
  }

  static get urlLanguage() {
    let lang = location.hostname.split('.')[0];
    lang = lang === 'www' ? 'en' : lang;

    if (this.isValid(lang)) return lang;

    lang = location.pathname.split('/')[1];
    if (this.isValid(lang)) return lang;

    return 'en';
  }

  static set urlLanguage(lang: string) {
    if (location.hostname === 'localhost' || location.hostname.includes('-origin') || !this.isValid(lang)) return;

    const hostNameArray = location.hostname.split('.');

    if (!this.isValid(hostNameArray[0])) {
      const pathNameArray = location.pathname.split('/');
      if (this.isValid(pathNameArray[1])) {
        pathNameArray[1] = lang;
        location.pathname = pathNameArray.join('/');
        return;
      }
    }

    lang = lang === 'en' ? 'www' : lang;
    if (hostNameArray[0] === lang) return;
    hostNameArray[0] = lang;
    location.hostname = hostNameArray.join('.');
  }

  static get browserLanguage() {
    const lang = navigator.language.split('-')[0];
    return this.isValid(lang) && lang;
  }

  static isValid(lang: string) {
    lang = lang === 'www' ? 'en' : lang;
    return this.siteLanguages.includes(lang);
  }

  static makeLanguageRedirect() {
    if (location.hostname === 'localhost' || location.hostname.includes('-origin')) return;

    if (!document.referrer) {
      this.cookieLanguage = this.urlLanguage;
    } else if (!/\/[a-z]{2,3}\.(?:[a-z]{3}\.)?uefa\.com/.test(document.referrer)) {
      return;
    } else {
      if (!this.cookieLanguage && this.browserLanguage) {
        this.cookieLanguage = this.browserLanguage;
        this.urlLanguage = this.browserLanguage;
      }

      if (this.cookieLanguage !== this.urlLanguage) {
        this.urlLanguage = this.cookieLanguage;
      }
    }
  }
}

declare global {
  interface Window {
    languageRedirection: boolean;
  }
}

if (window.languageRedirection) {
  LanguageService.makeLanguageRedirect();
}
